import { PolicyRequest } from '../policy-create';

export const POLICY_HISTORY_START = 'POLICY_HISTORY_START';
export const POLICY_HISTORY_SUCCESS = 'POLICY_HISTORY_SUCCESS';
export const POLICY_HISTORY_FAILED = 'POLICY_HISTORY_FAILED';

export interface PolicyHistoryResponse {
  records: PolicyRequest[];
  total: number;
}
export interface PolicyHistory {
  policyNumber: string;
  records: PolicyRequest[];
}
export interface PolicyHistoryStore {
  historyFetched?: boolean;
  historyError?: unknown;
  data?: PolicyHistory[];
}
